import { gql } from '@apollo/client';

const GET_LEGISLATION_PARTS = gql`
    query legislationParts {
        legislationParts
    }
`;

export default GET_LEGISLATION_PARTS;
